import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import './LinkCollectionPage.css';
import TopicFrame from "../../components/TopicFrame/TopicFrame";
import Subtopic from './../../components/Subtopic/Subtopic';
import toolLinksData from "./../../assets/json/toolLinks.json";
import youtubeLinksData from "./../../assets/json/youtubeLinks.json";
import internetLinksData from "./../../assets/json/internetLinks.json";

const ToolLinkList = () => {
	const [tools, setTools] = useState([]);
	const [youtubeLinks, setYoutubeLinks] = useState([]);
	const [internetLinks, setInternetLinks] = useState([]);

	useEffect(() => {
		setTools(toolLinksData.tools);
		setYoutubeLinks(youtubeLinksData.videos);
		setInternetLinks(internetLinksData.links);
	}, []);

	return (
		<>
			<TopicFrame Title="Linksammlung">
				<Subtopic Title="Einführung in Signaltheorie">
					<div className="toolLinkList" id="toolLinks">
						<div className="tool">
							<div className="bold">Link</div>
							<div className="bold">Themen</div>
							<div className="bold">Kanal</div>
						</div>
						{tools.map((tool, index) => (
							<div key={index} className="tool">
								<div className="toolName">{tool.name}</div>
								<div className="link">
									<span className="arrow"> </span>
									<a href={tool.link} target="_blank" rel="noopener noreferrer">
										{tool.link}
									</a>
								</div>
								<div className="description">{tool.description}</div>
							</div>
						))}
					</div>
				</Subtopic>
				<Subtopic Title="Youtube">
					<div className="youtubelinklist" id="youtubeLinks">
						<div className="tool">
							<div className="bold">Link</div>
							<div className="bold">Themen</div>
							<div className="bold">Kanal</div>
						</div>
						{youtubeLinks.map((youtubeLink, index) => (
							<div key={index} className="tool">
								<div>
									<span className="arrow"> </span>
									<a href={youtubeLink.link} target="_blank" rel="noopener noreferrer">
										{youtubeLink.title}
									</a>
								</div>
								<div>
									{youtubeLink.topics.map((topic, topicIndex) => (
										<span key={topicIndex}>
											<Link key={index} to={topic.link} className="intern">
												{topic.name}
											</Link>
											{topicIndex < youtubeLink.topics.length - 1 ? ', ' : ''}
										 </span>
									))}
								</div>
								<div>
									<span className="arrow"> </span>
									<a href={youtubeLink.channelLink} target="_blank" rel="noopener noreferrer">
										{youtubeLink.channel}
									</a>
								</div>
							</div>
						))}
					</div>
				</Subtopic>
				<Subtopic Title="Internet-Quellen">
					<div className="internetlinklist" id="internetLinks">
						<div className="tool">
							<div className="bold">Link</div>
							<div className="bold">Themen</div>
							<div className="bold">letzter Zugriff</div>
						</div>
						{internetLinks.map((internetLink, index) => (
							<div key={index} className="tool">
								<div>
									<span className="arrow"> </span>
									<a href={internetLink.url} target="_blank" rel="noopener noreferrer">
										{internetLink.url}
									</a>
								</div>
								<div>
									{internetLink.topics.map((topic, topicIndex) => (
										<span key={topicIndex}>
											<Link key={index} to={topic.link} className="intern">
												{topic.name}
											</Link>
											{topicIndex < internetLink.topics.length - 1 ? ', ' : ''}
										 </span>
									))}
								</div>
								<div>{internetLink.lastAccess}</div>
							</div>
						))}
					</div>
				</Subtopic>
			</TopicFrame>
		</>
	);
};

export default ToolLinkList;
